import { axios } from '@/plugins/axios';
import { Structure } from '@/types/structure';

/**
 * Classe de service pour les structures de radiologie
 */
export class StructureApiService {

	/**
	 * Récupère les structures de radiologie avec certains filtres
     *
	 * @param longitude Coordonnée en longitude
	 * @param latitude Coordonnée en latitude
	 * @param disabledPeopleAdapted Accepte les personnes handicapées
	 * @param chairMountedMammographe Avec mammographe adapté aux fauteuils
     *
	 * @returns Des structures de radiologie
	 */
	public static async getStructuresListByCoordinatesAndFeatures(
		longitude: number, latitude: number, disabledPeopleAdapted: boolean, chairMountedMammographe: boolean): Promise<Structure[]> {

		const structuresSearchParams = {
			longitude,
			latitude,
			...{ disabledPeopleAdapted: disabledPeopleAdapted ? disabledPeopleAdapted : null },
			...{ chairMountedMammographe: chairMountedMammographe ? chairMountedMammographe : null }
		};

		const response = await axios.get<Structure[]>('structures', {
			params: {
				...structuresSearchParams
			}
		});

		return response.data;
	}
}
